import { toast } from 'react-toastify';
import { IErrorModel, IPaginatedResponse } from '@core/models/generic.model';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import TraceabilityService from 'services/api/traceability.service';

// -------------------------------------------------------------------------

interface ITraceabilityState {
    loading: boolean;
    error: IErrorModel | undefined;
    traceability: []
}

const initialState: ITraceabilityState = {
    loading: false,
    error: {} as IErrorModel,
    traceability: []
};

// -------------------------------------------------------------------------

export const getTraceabilityThunk = createAsyncThunk<
    IPaginatedResponse,
    {
        size: number;
        page: number;
        serialNumber: string;
        ndcCode: string;
        fromDuns: string;
        toDuns: string;
        startDate: string;
        endDate: string;
    },
    { rejectValue: IErrorModel }
>(`/traceability/getTraceability`, async (params, { rejectWithValue }: any) => {
    try {
        const response: any = await TraceabilityService.getTraceability(params);
        return response.data.traceability;
    } catch (err: any) {
        toast.error(err.errorMessage || 'Failed to fetch traceability data', { autoClose: 5000 });
        return rejectWithValue(err);
    }
});

// -------------------------------------------------------------------------

const traceabilitySlice = createSlice({
    name: `traceability`,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get Traceability
        builder.addCase(getTraceabilityThunk.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getTraceabilityThunk.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.traceability = action.payload;
        });
        builder.addCase(getTraceabilityThunk.rejected, (state, action) => {
            state.loading = false;
            state.traceability = [];
            state.error = action.payload;
        });
    }
});

// -------------------------------------------------------------------------

export default traceabilitySlice;
export const traceabilityReducer = traceabilitySlice.reducer;

